export default __webpack_public_path__ + "static/media/landing-banner.c90877d6.svg";